import React from 'react';
import Icon from '../../../components/AppIcon';


const SystemNotifications = ({ notifications, onDismiss }) => {
  const getNotificationIcon = (type) => {
    switch (type) {
      case 'success':
        return { name: 'CheckCircle', color: 'text-success', bgColor: 'bg-success/10' };
      case 'warning':
        return { name: 'AlertTriangle', color: 'text-warning', bgColor: 'bg-warning/10' };
      case 'error':
        return { name: 'XCircle', color: 'text-error', bgColor: 'bg-error/10' };
      case 'info':
      default:
        return { name: 'Info', color: 'text-primary', bgColor: 'bg-primary/10' };
    }
  };

  return (
    <div className="bg-card rounded-lg shadow-sm overflow-hidden">
      <div className="p-4 md:p-5 lg:p-6 border-b border-border">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="Bell" size={20} className="text-primary" />
          </div>
          <div>
            <h2 className="text-lg md:text-xl font-semibold text-foreground">System Notifications</h2>
            <p className="text-sm text-muted-foreground">{notifications?.length} new updates</p>
          </div>
        </div>
      </div>
      <div className="p-4 md:p-5 lg:p-6">
        <div className="space-y-3">
          {notifications?.map((notification) => {
            const iconConfig = getNotificationIcon(notification?.type);
            return (
              <div
                key={notification?.id}
                className="bg-background rounded-lg p-4 hover-lift transition-organic"
              >
                <div className="flex items-start space-x-3">
                  <div className={`w-10 h-10 ${iconConfig?.bgColor} rounded-lg flex items-center justify-center flex-shrink-0`}>
                    <Icon name={iconConfig?.name} size={20} className={iconConfig?.color} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-foreground mb-1">{notification?.title}</p>
                    <p className="text-sm text-muted-foreground line-clamp-2">{notification?.message}</p>
                    <p className="text-xs text-muted-foreground mt-2">{notification?.time}</p>
                  </div>
                  <button
                    onClick={() => onDismiss(notification?.id)}
                    className="p-1 hover:bg-muted rounded transition-organic active-press"
                    aria-label="Dismiss notification"
                  >
                    <Icon name="X" size={16} className="text-muted-foreground" />
                  </button>
                </div>
              </div>
            );
          })}
        </div>

        {notifications?.length === 0 && (
          <div className="text-center py-8">
            <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-3">
              <Icon name="Bell" size={32} className="text-muted-foreground" />
            </div>
            <p className="text-sm text-muted-foreground">No new notifications</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SystemNotifications;